import { useCallback, useEffect, useState } from "react";
import { getClinicProfile, getLogoFullUrl } from "../api/clinic";

export const CLINIC_LOGO_EVENT = "clinicops:clinic-logo";

export function publishClinicLogo(url) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CLINIC_LOGO_EVENT, { detail: { url: url || null } }));
}

function withLogoVersion(url, stamp) {
  if (!url) return null;
  return `${url}${url.includes("?") ? "&" : "?"}v=${stamp}`;
}

export function useClinicBrand(hasClinic) {
  const [clinicProfile, setClinicProfile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [stamp, setStamp] = useState(() => Date.now());

  const load = useCallback(() => {
    if (!hasClinic) {
      setClinicProfile(null);
      return;
    }
    getClinicProfile()
      .then(setClinicProfile)
      .catch(() => setClinicProfile(null));
  }, [hasClinic]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const onLogo = (event) => {
      const url = event.detail?.url || null;
      if (url && String(url).startsWith("blob:")) {
        setPreviewUrl(url);
        return;
      }
      setPreviewUrl(null);
      setStamp(Date.now());
      load();
    };
    window.addEventListener(CLINIC_LOGO_EVENT, onLogo);
    return () => window.removeEventListener(CLINIC_LOGO_EVENT, onLogo);
  }, [load]);

  const stored = getLogoFullUrl(clinicProfile?.logoUrl ?? clinicProfile?.LogoUrl);
  const logoUrl = previewUrl || withLogoVersion(stored, stamp);

  return { clinicProfile, logoUrl };
}
